'use client';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@savvy-kit/components/dropdown-menu';
import IconButton from '@savvy-kit/components/icon-button';
import { EllipsisVertical } from 'lucide-react';

import { useHouseholdArchive } from './hooks/use-household-archive';

type ClientRowDropdownProps = {
  readonly householdId: string;
  readonly householdName: string;
};

export function ClientRowDropdown({ householdId, householdName }: ClientRowDropdownProps) {
  const { handleArchive: doArchive } = useHouseholdArchive();

  const handleArchive = async () => {
    await doArchive(householdId, householdName);
  };

  return (
    <div
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <DropdownMenu>
        <DropdownMenuTrigger
          render={
            <IconButton variant="ghost" size="sm" aria-label="More options">
              <EllipsisVertical />
            </IconButton>
          }
        />
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={handleArchive}>Archive household</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
